import './Layout.scss'
import Header from './Header/Header'
import Footer from './Footer/Footer'
import Secure from './Secure/Secure'
import ResponsiveState from './ResponsiveState/ResponsiveState'

const Layout = (props) => {
  const header = props.header !== undefined ? props.header : true
  const footer = props.footer !== undefined ? props.footer : true

  return (
    <div id="layout" className={`${props.fullsize === true ? 'fullsize' : ''}`}>
      <Secure authRequired={props.authRequired}>
        <ResponsiveState />
        {header && <Header />}
        <div id="content-container">{props.children}</div>
        {footer && <Footer />}
      </Secure>
    </div>
  )
}

export default Layout
